import Vue from 'vue';
import Router from 'vue-router';

import Account from './views/Account.vue';
import Workers from './views/Workers.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/workers',
      name: 'workers',
      component: Workers,
    },
    {
      path: '/account',
      name: 'account',
      component: Account,
    },
    // {
    //   path: '/home',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ],
});
